module.exports = __webpack_public_path__ + "img/img-spadegaming.a5792baa.png";